import CondicionCreateView from './views/CondicionCreateView.vue'

export default [
  {
    path: '/condicion-salarial-nueva/:personalId/:clubId',
    name: 'nuevaCondicionSalarial',
    component: CondicionCreateView
  },
  {
    path: '/condicion-detalle/:id',
    name: 'detalleCondicion',
    component: CondicionCreateView
  },
  {
    path: '/condicion/renovar/:id',
    name: 'renovarCondicion',
    component: CondicionCreateView
  }
]
